import type { MapLayerId } from './types';

/**
 * Canonical visual stacking order for all renderer-owned SVG layers.
 *
 * `createMapScene` filters this list instead of trusting caller order, so labels stay above their
 * matching shapes and camera labels stay above camera icons for every consumer.
 */
export const MAP_LAYER_ORDER: readonly MapLayerId[] = [
  'fields',
  'field-labels',
  'streets',
  'cameras',
  'camera-labels',
];

/**
 * Base width and height of the canonical camera icon, in map coordinate units.
 *
 * Page-provided camera `sizeMultiplier` values scale this dimension before the SVG transform is built.
 */
export const MAP_CAMERA_BASE_ICON_SIZE = 24;

/** Source square viewport size of the canonical camera path. Used to map the path to icon size. */
export const CAMERA_ICON_VIEWBOX_SIZE = 488.3;

/** Immutable SVG `path` data used for every renderer-owned camera marker icon. */
export const CAMERA_ICON_PATH_DATA =
  'M488.3,142.5v203.1c0,15.7-17,25.5-30.6,17.7l-84.6-48.8v13.9c0,41.8-33.9,75.7-75.7,75.7H75.7C33.9,404.1,0,370.2,0,328.4 V159.9c0-41.8,33.9-75.7,75.7-75.7h221.8c41.8,0,75.7,33.9,75.7,75.7v13.9l84.6-48.8C471.3,117,488.3,126.9,488.3,142.5z';
